export default __webpack_public_path__ + "static/23-81077a873ec26534a79a2dbb5dda3adc.png";